import React, {useContext} from "react";
import {ConfigContext, CurrentContext, lengthToType} from "../../App";
import Explanation from "../elements/Explanation";
import NextButton from "../elements/NextButton";
import InsideColorButtonGroup from "../InsideColorButtonGroup";
import TextButtonGroup from "../TextButtonGroup";
import TextCheckboxButtonGroup from "../TextCheckboxButtonGroup";
import TotalPrice from "../TotalPrice";

import logo from "../../vanchanger_logo_nebelblau.svg";

function getUnique(arr: any[], key: string) {
    return arr.map(c => c[key])
            .filter((value, index, array) => array.indexOf(value) === index);
}

function Inside() {
    const config = useContext(ConfigContext);
    const current = useContext(CurrentContext);

    // console.log(config.car.car[0].typ)

    return <div className="flex configuration-part">
        <div className="flex configuration-part-headline">
            <img className="part-headline-img"
                 src={logo}
                 alt="logo"/>
            <h2>Innenraum</h2>
        </div>

        <TextButtonGroup fullwidth
                         heading={"Innenausstattung"}
                         name={"inside_version"}
                         elements={getUnique(config.inside.versions, "name")}
                         featureList={
                             config.inside.versions
                                     .filter(v => v.typ === lengthToType(current.length))
                                     .map(c => c.info)
                                     .map(i => <div className="package-summary">
                                                 <ul>
                                                     {i.map(e => <li>{e.item} {
                                                             e.info && (
                                                                     <Explanation>{e.info.join(", ")}</Explanation>
                                                             )
                                                     }</li>)}
                                                 </ul>
                                             </div>,
                                     )
                         }
        />

        {current.inside_version === "Basic Camper" && (
                <>
                    <TextCheckboxButtonGroup
                            fullwidth
                            heading={"Wähle einzelne Module:"}
                            name={"modules"}
                            elements={config.modules.map(t => t.name)}
                            images={config.modules.map(c => c.image ? `modules/${c.image}.png` : undefined)}
                    />
                    <p className={"modul-info"}>Modulfarbe entspricht der Innenraumfarbe</p>
                </>
        )}


        <InsideColorButtonGroup heading={"Innenraumfarbe"}
                                name={"inside_color"}
                                elements={config.colorInside}
        />

        <NextButton/>
    </div>;
}

export default Inside;
